import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import router from '@/router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    addressBook: [],
    loading: false,
    error: null
  },
  mutations: {
    setAddressBook (state, payload) {
      state.addressBook = payload
    },
    addAddress (state, payload) {
      state.addressBook.push(payload)
    },
    editAddress (state, payload) {
      let address = state.addressBook.find((record) => {
        return record.id === payload.id
      })

      let index = state.addressBook.indexOf(address)

      state.addressBook.splice(index, 1)

      address.first_name = payload.first_name
      address.surname = payload.surname
      address.address = payload.address
      address.city = payload.city
      address.postcode = payload.postcode
      address.country = payload.country
      address.note = payload.note

      state.addressBook.push(address)
    },
    deleteAddress (state, payload) {
      let address = state.addressBook.find((record) => {
        return record.id === payload
      })

      let index = state.addressBook.indexOf(address)

      state.addressBook.splice(index, 1)
    },
    setUser (state, payload) {
      state.user = payload
    },
    updateUserName (state, payload) {
      state.user.name = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    }
  },
  actions: {
    registerUser ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          const newbie = firebase.auth().currentUser
          newbie.updateProfile({
            displayName: payload.name
          })
            .then(() => {
              commit('setLoading', false)
              const newUser = {
                id: user.user.uid,
                name: payload.name
              }
              commit('setUser', newUser)
            })
            .catch(error => {
              commit('setLoading', false)
              commit('setError', error)
              console.log(error)
            })
        })
        .catch(error => {
          commit('setError', error)
          commit('setLoading', false)
          console.log(error)
        })
    },
    signInUser ({ commit, dispatch }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          commit('setLoading', false)
          const signedUser = {
            id: user.user.uid,
            name: user.user.displayName
          }
          commit('setUser', signedUser)
          dispatch('getAddressBook', user.user.uid)
        })
        .catch(error => {
          commit('setError', error)
          commit('setLoading', false)
          console.log(error)
        })
    },
    autoSignIn ({ commit }, payload) {
      const signedUser = {
        id: payload.uid,
        name: payload.displayName
      }
      commit('setUser', signedUser)
    },
    updateUser ({ commit }, payload) {
      commit('setLoading', true)

      let user = firebase.auth().currentUser

      user.updateProfile({
        displayName: payload.name
      })
      .then(() => {
        commit('updateUserName', payload.name)
        if (payload.password) {
          let userPass = firebase.auth().currentUser
          userPass.updatePassword(payload.password)
            .then(() => {
              router.push('address-book')
            })
            .catch(error => {
              // error
            })
        }
      })
      .catch(error => {
        // error
      })

    },
    signOut ({ commit }) {
      firebase.auth().signOut()
      commit('setUser', null)
      router.push('login')
    },
    getAddressBook ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.database().ref('addressBook/' + payload).once('value')
        .then(data => {
          const book = []

          const obj = data.val()
          for (let key in obj) {
            book.push({
              id: key,
              first_name: obj[key].first_name,
              surname: obj[key].surname,
              address: obj[key].address,
              city: obj[key].city,
              postcode: obj[key].postcode,
              country: obj[key].country,
              note: obj[key].note,
              created_at: obj[key].created_at
            })
          }

          // console.log(book)

          commit('setAddressBook', book)
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error)
          commit('setLoading', false)
          console.log(error)
        })
    },
    addAddress ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      const address = {
        first_name: payload.first_name,
        surname: payload.surname,
        address: payload.address,
        city: payload.city,
        postcode: payload.postcode,
        country: payload.country,
        note: payload.note,
        created_at: payload.created_at,
        updated_at: payload.updated_at
      }

      // reach out to firebase, store it and get ID
      firebase.database().ref('addressBook/' + payload.user_id).push(address)
        .then((data) => {
          console.log(data)

          address.id = data.key

          commit('addAddress', address)
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error)
          commit('setLoading', false)
          console.log(error)
        })
    },
    editAddress ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      const address = {
        first_name: payload.first_name,
        surname: payload.surname,
        address: payload.address,
        city: payload.city,
        postcode: payload.postcode,
        country: payload.country,
        note: payload.note,
        created_at: payload.created_at,
        updated_at: payload.updated_at
      }

      // reach out to firebase, edit address and commit
      firebase.database().ref('addressBook/' + payload.user_id).child(payload.address_id).update(address)
        .then((data) => {
          // commit
          address.id = payload.address_id
          commit('editAddress', address)
          commit('setLoading', false)
        })
        .catch(error => {
          console.log(error)
          commit('setError', error)
          commit('setLoading', false)
        })
    },
    deleteAddress ({ commit }, payload) {
      commit('setLoading', true)

      firebase.database().ref('addressBook/' + payload.user_id).child(payload.address_id).remove()
        .then(data => {
          console.log(data)
          commit('deleteAddress', payload.address_id)
          commit('setLoading', false)
          router.push('/address-book')
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    setError ({ commit }, payload) {
      commit('setError', payload)
    },
    clearError ({ commit }) {
      commit('clearError')
    }
  },
  getters: {
    sortedAddressBook (state) {
      return state.addressBook.sort((recordA, recordB) => {
        let sur1 = recordA.surname.toLowerCase()
        let sur2 = recordB.surname.toLowerCase()
        return (sur1 < sur2) ? -1 : (sur1 > sur2) ? 1 : 0
      })
    },
    rawAddressBook (state) {
      return state.addressBook
    },
    user (state) {
      return state.user
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    }
  }
})
